export default (maxLines, initialState = true) => ({
  lineHeight: 0,
  maxHeight: 0,
  height: 0,
  maxLines,
  state: initialState,
  lock: false,
  open() {
    if (this.lock) {
      return;
    }
    this.lock = true;
    this.$root.style.transition = "height 0.25s cubic-bezier(0.4, 0, 0.2, 1)";
    let height = parseInt(window.getComputedStyle(this.$root).height, 10);
    this.$root.style.height = this.height + "px";
    this.$root.classList.remove("truncate-text--truncated");
    this.$root.style["-webkit-line-clamp"] = null;
    const interval = setInterval(() => {
      if (this.height > height) {
        height += (this.height - this.maxHeight) / 3;
        this.$root.style.height = height + "px";
      } else {
        clearInterval(interval);
        this.$root.style.transition = null;
        this.$root.style.height = null;
        this.lock = false;
      }
    }, 25);
  },
  truncateImmediately() {
    this.$root.style.height = this.maxHeight + "px";
    this.$root.classList.add("truncate-text--truncated");
    this.$root.style["-webkit-line-clamp"] = this.maxLines;
  },
  openImmediately() {
    this.$root.style.height = this.height + "px";
    this.$root.classList.remove("truncate-text--truncated");
    this.$root.style["-webkit-line-clamp"] = null;
  },
  truncate() {
    if (this.lock) {
      return;
    }
    this.lock = true;
    this.$root.style.transition = "height 0.25s cubic-bezier(0.4, 0, 0.2, 1)";
    let height = this.height;
    this.$root.style.height = this.height + "px";
    const interval = setInterval(() => {
      if (height > this.maxHeight) {
        height -= (this.height - this.maxHeight) / 5;
        this.$root.style.height = height + "px";
      } else {
        clearInterval(interval);
        this.$root.style.transition = "";
        setTimeout(() => {
          this.$root.classList.add("truncate-text--truncated");
          this.$root.style["-webkit-line-clamp"] = this.maxLines;
          this.lock = false;
        }, 250);
      }
    }, 25);
  },
  updateParams() {
    this.$nextTick(() => {
      this.$root.classList.add("truncate-text");
      this.height = this.$root.scrollHeight;
      this.lineHeight = parseInt(
        window.getComputedStyle(this.$root).lineHeight,
        10
      );
      this.maxHeight = this.lineHeight * this.maxLines;
      if (this.state) {
        this.truncateImmediately();
      }
    });
  },
  onResize() {
    this.openImmediately();
    this.updateParams();
  },
  init() {
    this.updateParams();
    this.$watch("state", (value) => {
      if (value) {
        this.truncate();
      } else {
        this.open();
      }
    });
  },
});
